import "./headboardSimple.scss";

import React, { useContext } from "react";

import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import Button from "../../atoms/button/button";
import GlobalContext from "../../../contexts/globalContext";
import HeadboardSimpleProps from "./headboard-simple.types";

const HeadboardSimple = ({
  title,
  bgImage,
  breadcrumb,
  description,
  btnText,
  btnLink,
  darkMode = false,
  isHome,
}: HeadboardSimpleProps) => {
  const globalContext = useContext(GlobalContext);
  return (
    <div
      className={`o-headboard-simple ${
        darkMode ? "o-headboard-simple--dark" : ""
      }`}
      style={{
        backgroundImage: `url(${bgImage})`,
        marginTop: "5rem",
      }}
    >
      <div className="o-headboard-simple__container">
        {breadcrumb && (
          <div className={`o-headboard-simple__migadepan`}>
            <Breadcrumb content={breadcrumb} />
          </div>
        )}
        <h1 className="o-headboard-simple__title">{title}</h1>
        <div className="o-headboard-simple__contentGrid">
          {description && (
            <div className="o-headboard-simple__container-description">
              <p className="o-headboard-simple__description">{description}</p>
            </div>
          )}
          {btnText && (
            <div className="o-headboard-simple__button">
              <Button
                type="button"
                text={btnText}
                classname={`secondary`}
                isDisabled={false}
                onClickAction={() => {
                  if (isHome === false) {
                    globalContext.gigyaContext.gigyaAccount
                      ? (window.location.href = `${window.location.origin}${window.location.pathname}${btnLink}`)
                      : globalContext.gigyaContext.login();
                  } else {
                    window.location.href = `${window.location.origin}${window.location.pathname}${btnLink}`;
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default HeadboardSimple;
